import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './SectionIntro.scss'

const SectionIntro = props => {
	const { header, body, light } = props
	return (
		<div styleName="container">
			<h3 styleName={light ? 'header-light' : 'header'}>{header}</h3>
			{body ? (
				<div styleName={light ? 'body-light' : 'body'}>{body}</div>
			) : (
				''
			)}
		</div>
	)
}
SectionIntro.propTypes = {
	header: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	body: React.PropTypes.any
}

export default CSSModules(SectionIntro, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/SectionIntro.js